export const BRAND_PF = 'vantagePF';
export const BRAND_EQX = 'vantageEQX';
export const BRAND_NON_PF = 'vantage';

export const BRAND_PF_NAME = 'Vantage Price Forbes';
export const BRAND_EQX_NAME = 'Vantage Equinox';
export const BRAND_NON_PF_NAME = 'Vantage Ardonagh Specialty';

export const EQX = 'EQX';
export const ARDONAGH = 'ARDONAGH';

export const BRAND_PF_DOMAINS = ['vantage-v1.priceforbes.com'];
export const BRAND_EQX_DOMAINS = ['vantage-v1.equinoxunderwriting.com', 'vantage-v1.equinoxunderwriting.co.uk'];
export const BRAND_NON_PF_DOMAINS = ['vantage-v1.ardonaghspecialty.com'];
